import { render, staticRenderFns } from "./ExamWatch.vue?vue&type=template&id=672344b3&scoped=true&"
import script from "./ExamWatch.vue?vue&type=script&lang=js&"
export * from "./ExamWatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672344b3",
  null
  
)

export default component.exports